// src/utils/calibrationApi.js
//
// AISC §1.14 Calibration Phase 1 — frontend API client.
// Mirrors the convention of detailerQualificationsApi.js, rfisApi.js, etc.

import ApiCall from "./apicall";

// ── Instrument catalog (per-tenant) ─────────────────────────────────────────
export const calibrationInstrumentsApi = {
  list: () => ApiCall.get("/calibration/instruments"),
  get: (id) => ApiCall.get(`/calibration/instruments/${id}`),
  create: (payload) => ApiCall.post("/calibration/instruments", payload),
  update: (id, payload) => ApiCall.put(`/calibration/instruments/${id}`, payload),
  remove: (id) => ApiCall.delete(`/calibration/instruments/${id}`),
};

// ── Instrument units (physical gages) ───────────────────────────────────────
export const calibrationUnitsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return ApiCall.get(`/calibration/units${qs ? `?${qs}` : ""}`);
  },
  kpis: () => ApiCall.get("/calibration/units/kpis"),
  get: (id) => ApiCall.get(`/calibration/units/${id}`),
  create: (payload) => ApiCall.post("/calibration/units", payload),
  update: (id, payload) => ApiCall.put(`/calibration/units/${id}`, payload),
  outOfService: (id, reason) => ApiCall.post(`/calibration/units/${id}/out-of-service`, { reason }),
};

// ── Calibration events (append-only) ────────────────────────────────────────
export const calibrationEventsApi = {
  listForUnit: (unitId) => ApiCall.get(`/calibration/units/${unitId}/events`),
  recordForUnit: (unitId, payload) => ApiCall.post(`/calibration/units/${unitId}/events`, payload),
  get: (id) => ApiCall.get(`/calibration/events/${id}`),
};

// ── Status display helpers ──────────────────────────────────────────────────
export const STATUS_LABELS = {
  unverified: "Unverified",
  in_cal: "In-Cal",
  due_soon: "Due Soon",
  overdue: "Overdue",
  rejected: "Rejected",
  out_of_service: "Out of Service",
};

export const STATUS_COLORS = {
  unverified: "default",
  in_cal: "success",
  due_soon: "warning",
  overdue: "error",
  rejected: "error",
  out_of_service: "default",
};

export const CATEGORY_LABELS = {
  tape: "Tape",
  dft: "DFT",
  weld_gage: "Weld Gage",
  bolt_tension: "Bolt Tension",
  multimeter: "Multimeter",
  hygrometer: "Hygrometer",
  mag_temp: "Magnetic Temp",
  fab_square: "Fabrication Square",
  v_wac: "V-Wac",
  transfer_gage: "Transfer Gage",
  welding_machine: "Welding Machine",
  wire_feeder: "Wire Feeder",
  general: "General",
  other: "Other",
};

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const due = new Date(dateStr);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.floor((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}
